import PageSubTitle from "@/components/Form/PageSubTitle/PageSubTitle";
import React, { useEffect, useState } from "react";
import {
  CLAIM_STAGE_NAME,
  STAGE_COMMENT_NAME,
} from "../Constants";
import { ClaimSetupDescription } from "./type";
import { useForm } from "react-hook-form";
import {
  MotifProgressLoader,
  MotifErrorMessage,
  MotifFormField,
  MotifFileUploader,
  MotifFileUploaderItem,
  MotifIcon,
  MotifButton,
} from "@ey-xd/motif-react";
import ControlSelect from "./ControlSelectClaimSetupDescription";
import { useListClaimStagesByCaseQuery } from "@/services/stages/claimStagesByCaseReducer";
import Button from "@/components/Form/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  setStageSelectedItems,
  resetDescriptionState,
  setStageDocument,
} from "./descriptionSlice";
import { useTranslation } from "react-i18next";
import { DescriptionItemsState } from "./descriptionSlice";
import ConfirmationModal from "@/components/Modal/ConfirmationModal/ConfirmationModal";
import { useNavigate, useParams } from "react-router-dom";
import useResetAllClaimItemsStore from "../useResetAllClaimItemsStore";
import ControlInputBox from "../ClaimItems/ControlInputBoxClaimItems";
import { actionIcDescription24px } from "@ey-xd/motif-react/assets/icons";
import { setDiscardEditMode } from "@/components/Modal/ConfirmationModal/discardchanges";
import { fileExtensions } from "@/services/documents/documentsReducer";
import {
  CANCEL_BUTTON_VARIANT,
  DOWNLOAD_IMG_VARIANT,
  getCommonDownloadImg,
  NEXT_BUTTON_VARIANT,
} from "@/components/Images/CommonImages";
import { ActiveTabsOrder } from "@/menuData";
interface RootState {
  claimSetupDescription: DescriptionItemsState;
}
interface DebtorProps {
  goToNextTab: () => void;
  file: File | null;
  setFile: (file: File | null) => void;
}
export default function Description({
  goToNextTab,
  file,
  setFile,
}: DebtorProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { caseId } = useParams();
  const safeCaseId = caseId ?? "";
  const dispatch = useDispatch();
  const [isVisible, setIsVisible] = useState(false);
  const resetAllClaimItemsStore = useResetAllClaimItemsStore();

  const stageDocumentState = useSelector(
    (state: any) => state?.claimSetupDescription?.stageDocument
  );

  const filename = file?.name || stageDocumentState?.document;

  const stageName = useSelector(
    (state: RootState) =>
      state.claimSetupDescription?.selectedStageCompleteDetail?.name
  );

  const {
    handleSubmit,
    control,
    setValue,
    getValues,
    formState: { errors, dirtyFields },
    watch,
    reset,
  } = useForm<ClaimSetupDescription>({
    defaultValues: {
      //claimStage: stageName,
      fileDislayName: stageDocumentState?.displayName || "",
      stageDocumentComment: stageDocumentState?.comment || "",
    },
  });
  const {
    data: stageData,
    isLoading: isStageDataLoading,
    error: errorInStageData,
  } = useListClaimStagesByCaseQuery(safeCaseId);

  let CLAIM_STAGE_OPTIONS = [];
  if (!isStageDataLoading && !errorInStageData && stageData) {
    const claimStageNames = stageData
      .map((item: { name: string }) => item.name)
      .filter((name: string) => name !== "");
    CLAIM_STAGE_OPTIONS = claimStageNames.map((name: string) => ({
      label: name,
      value: name,
    }));
  } else {
    CLAIM_STAGE_OPTIONS = [{ label: "", value: "" }];
  }

  if (isStageDataLoading) {
    <MotifProgressLoader show variant="default" />;
  }

  if (errorInStageData) {
    <MotifErrorMessage
      style={{
        textAlign: "center",
        display: "block",
        alignItem: "center",
      }}
    >
      {t("global.globalNotifications.wentWrong")}
    </MotifErrorMessage>;
  }

  const watchStageSelection = watch(CLAIM_STAGE_NAME);

  const selectedStageCompleteDetail = stageData?.find(
    (stage: { name: string }) => stage.name === watchStageSelection
  );

  const onSubmit = async () => {
    // dispatch(setStageSelectedItems(selectedStageCompleteDetail));
    moveDataToStoreandMoveToNextTab();
  };

  const moveDataToStoreandMoveToNextTab = () => {
    dispatch(setStageSelectedItems(selectedStageCompleteDetail));
    dispatch(
      setStageDocument({
        caseId: caseId,
        fileName: file ? file.name : null,
        displayName: file ? file.name.split(".")?.[0] : null,
        comment: watch(STAGE_COMMENT_NAME),
        document: file?.name || null,
      })
    );
    goToNextTab();
  };
  console.log(file,"filegokul")

  const handleDescriptionCancel = () => {
    setIsVisible(false);
    dispatch(setDiscardEditMode({ editMode: true }));
  };

  const handleDescriptionReset = () => {
    dispatch(resetDescriptionState());
    setIsVisible(false);
    reset({
      claimStage: "",
    });
    resetAllClaimItemsStore();
    navigate(`/case/${caseId}?activeTab=${ActiveTabsOrder.CLAIM}`);
  };

  useEffect(() => {
    if (stageName && stageData) {
      const stage = stageName;
      setValue(CLAIM_STAGE_NAME, stage || "", { shouldDirty: false });
    }
  }, [stageName, setValue, stageData]);

  const handleFileChange = (files: any) => {
    const file = Array.isArray(files) ? files[0] : files;
    setFile(file);
  };

  const handleFileDownload = () => {
    if (file) {
      const filePath = URL.createObjectURL(file);
      const a = document.createElement("a");
      a.href = filePath;
      a.download = file?.name ? file.name : "downloaded_file";
      const downloadControls =
        document.getElementsByClassName("motif-modal-content")[0] ||
        document.body;
      downloadControls.appendChild(a);
      a.click();
      downloadControls.removeChild(a);
      URL.revokeObjectURL(filePath);
    }
  };
  let discardTrig = Object.keys(dirtyFields).length > 0 ? true : false;
  let discardDetails = useSelector((e: any) => e.discardChangesDatas.data);

  useEffect(() => {
    dispatch(
      setDiscardEditMode({
        editMode:
          discardDetails?.editMode || discardTrig || file ? true : false,
      })
    );
    return () => {
      dispatch(setDiscardEditMode({ editMode: false }));
    };
  }, [dispatch, discardTrig, file, discardDetails?.editMode]);
  return (
    <>
      <PageSubTitle
        title={"pages.claims.claimCreate.detailsTab.title"}
        description={"pages.claims.claimCreate.detailsTab.description"}
      />
      {/* <form > */}
      <div className="motif-row pad-b-20">
        <div className="motif-col-lg-6">
          <ControlSelect
            name={CLAIM_STAGE_NAME}
            control={control}
            required={true}
            showLabel={true}
            label={
              "pages.claims.claimCreate.detailsTab.formLabelsDetails.claimStage"
            }
            options={CLAIM_STAGE_OPTIONS}
            setValue={setValue}
            getValues={getValues}
          />
          {errors[CLAIM_STAGE_NAME] &&
            errors[CLAIM_STAGE_NAME].type === "required" && (
              <MotifErrorMessage>
                {t(
                  "pages.claims.claimCreate.detailsTab.validationMessages.claimStageRequired"
                )}
              </MotifErrorMessage>
            )}
        </div>
      </div>

      <div className="motif-row pad-b-20">
        <div className="motif-col-lg-9">
          {/* <UploadStageDocument
              files={files}
              setFiles={setFiles}
            />  */}
          <div className="upload-doc">
            <PageSubTitle
              title={"pages.claims.claimCreate.detailsTab.stageDocumentTitle"}
              description={""}
            />
            <div className="motif-row">
              <div className="motif-col-lg-6">
                <ControlInputBox
                  name={STAGE_COMMENT_NAME}
                  /*@ts-ignore */
                  control={control}
                  required={false}
                  isTextArea={false}
                  label={
                    "pages.claims.claimCreate.detailsTab.formLabelsDetails.comment"
                  }
                  showLabel={true}
                  //value={stageDocumentState?.comment}
                />
              </div>
            </div>
            <div className="motif-row mar-t-30">
              <div className="motif-col-lg-12">
                <MotifFormField>
                  <MotifFileUploader
                    id="my-id"
                    label={t(
                      "pages.claims.claimCreate.detailsTab.formLabelsDetails.uploadTitle"
                    )}
                    labelDescription={t(
                      "pages.claims.claimCreate.detailsTab.formLabelsDetails.UploadDescription"
                    )}
                    onDrop={(files) => handleFileChange(files)}
                    maxFileSize={10000}
                    accept={fileExtensions.default}
                  >
                    {file && (
                      <div className="mar-t-30">
                        <MotifFileUploaderItem
                          fileIcon={<MotifIcon src={actionIcDescription24px} />}
                          customButton={
                            <MotifButton
                              onClick={handleFileDownload}
                              variant={DOWNLOAD_IMG_VARIANT}
                              type="button"
                            >
                              {getCommonDownloadImg()}
                            </MotifButton>
                          }
                          removable={true}
                          fileName={filename}
                          onRemove={() => {
                            handleFileChange(null);
                          }}
                          error={
                            (file && file.size >= fileExtensions.maxFileSize) ||
                            false
                          }
                          errorText={t(
                            "pages.claims.stageStatusPopup.filesizeExceedsLimit",
                            {
                              filesize: "250",
                            }
                          )}
                        />
                      </div>
                    )}
                  </MotifFileUploader>
                </MotifFormField>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="display-flex justify-content-end mar-t-70 button-container sticky-footer">
        <Button
          type="button"
          label={t("global.globalActions.cancel")}
          variant={CANCEL_BUTTON_VARIANT}
          className="cancelBtn"
          onClickHandler={() => {
            if (discardTrig || file ? true : false) {
              setIsVisible(true);
              dispatch(setDiscardEditMode({ editMode: false }));
            } else {
              handleDescriptionReset();
            }
          }}
        />
        <Button
          label={t("global.globalActions.next")}
          variant={NEXT_BUTTON_VARIANT}
          disabled={(file && file.size >= fileExtensions.maxFileSize) || false}
          type="button"
          onClickHandler={handleSubmit(onSubmit)}
        />
      </div>
      <ConfirmationModal
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        cancelBtnApproveHandler={handleDescriptionReset}
        cancelBtnRejectHandler={handleDescriptionCancel}
      />
      {/* </form> */}
    </>
  );
}
